import React from "react";

const AddContext = React.createContext();

export default AddContext;